import {tasksSvg as Icon__small__tasksSvg} from '../Icon__small/Icon__small--tasks.js'

export var tasks = {
  name: 'tasks',
  category: 'icon',
  colorable: true,
  svg: Icon__small__tasksSvg,
};
